var _path, _path2, _path3, _path4, _path5, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnDesignPatterns(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 16.333V52.6972C56 54.523 54.632 56.003 52.9444 56.003H4.05556C2.36802 56.003 1 54.523 1 52.6972V16.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.5C1 2.11929 2.36802 1 4.05556 1H52.9444C54.632 1 56 2.11929 56 3.5V16H1V3.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.61108 10.1113C9.43953 10.1113 10.1111 9.43978 10.1111 8.61133C10.1111 7.78288 9.43953 7.11133 8.61108 7.11133C7.78263 7.11133 7.11108 7.78288 7.11108 8.61133C7.11108 9.43978 7.78263 10.1113 8.61108 10.1113Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7778 10.1113C18.6062 10.1113 19.2778 9.43978 19.2778 8.61133C19.2778 7.78288 18.6062 7.11133 17.7778 7.11133C16.9493 7.11133 16.2778 7.78288 16.2778 8.61133C16.2778 9.43978 16.9493 10.1113 17.7778 10.1113Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9445 10.1113C27.7729 10.1113 28.4445 9.43978 28.4445 8.61133C28.4445 7.78288 27.7729 7.11133 26.9445 7.11133C26.116 7.11133 25.4445 7.78288 25.4445 8.61133C25.4445 9.43978 26.116 10.1113 26.9445 10.1113Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 26,
    width: 35,
    height: 18,
    stroke: "#2884FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDesignPatterns);
export default __webpack_public_path__ + "static/media/icn-design-patterns.5a37842b198f5a45485c498faf24676e.svg";
export { ForwardRef as ReactComponent };